module.exports = __webpack_public_path__ + "img/iPhone@3x.73458b51.png";